import React from 'react';

export const MailIcon = ({size}:any) =>
{
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink" 
        width={`${size}px`}
        height={`${size}px`}
        viewBox="0 0 24 24">
            <rect style={{fill: 'none'}} width="24" height="24"/>
            <rect style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} width="22" height="14" rx="1" transform="translate(1 5)"/>
            <path style={{ fill: 'none', stroke: '#49cb5c', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M4.96,8.88l5.86,4.26a2.011,2.011,0,0,0,2.36,0l5.86-4.26"/>
            <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M17.87,14.27,23,18a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1l5.13-3.73"/>
        </svg>
    )
}

MailIcon.defaultProps = {
    size: 16,
}

export const LockIcon = ({size}:any) =>
{
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink" 
        width={`${size}px`}
        height={`${size}px`}
        viewBox="0 0 24 24">
            <rect style={{fill: 'none'}} width="24" height="24"/>
            <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M3,16.646v4.3A1.014,1.014,0,0,0,3.956,22H20.044A1.014,1.014,0,0,0,21,20.942V11.058A1.014,1.014,0,0,0,20.044,10H3.956A1.014,1.014,0,0,0,3,11.058v1.916"/>
            <circle style={{stroke: '#49cb5c',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} cx="1.755" cy="1.755" r="1.755" transform="translate(10.245 13.177)"/>
            <line style={{stroke: '#49cb5c',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} y1="2.136" transform="translate(12 16.687)"/>
            <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M6.617,0h0a6.617,6.617,0,0,1,6.617,6.617V8a0,0,0,0,1,0,0H0A0,0,0,0,1,0,8V6.617A6.617,6.617,0,0,1,6.617,0Z" transform="translate(5.383 2)"/>
        </svg>
    )
}

LockIcon.defaultProps = {
    size: 16,
}

export const DashboardIcon = ({size, className, color}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 24 24">
                <rect style={{fill: 'none'}} width="24" height="24"/>
                <rect style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} width="7.945" height="5.499" rx="1" transform="translate(13.593 4)"/>
                <rect style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} width="7.945" height="5.499" rx="1" transform="translate(10.945 20.086) rotate(180)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M2.734,9.02V10.9a1,1,0,0,0,1,1h5.94a1,1,0,0,0,1-1V4.96a1,1,0,0,0-1-1H3.734a1,1,0,0,0-1,1V6.84" transform="translate(0.269 0.043)"/>
                <path style={{stroke: '#49cb5c',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M21.264,14.983V13.1a1,1,0,0,0-1-1h-5.94a1,1,0,0,0-1,1v5.94a1,1,0,0,0,1,1h5.94a1,1,0,0,0,1-1v-1.88" transform="translate(0.269 0.043)"/>
            </svg>
        </span>
    )
}

DashboardIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const MachineIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 24 24">
                <rect style={{fill: 'none'}} width="24" height="24"/>
                <rect style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} width="13.275" height="4.106" rx="2.053" transform="translate(2 17.445)"/>
                <path style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M11.985,8.989l3.648-6.274,4.509,1.733L21.9,10.3" transform="translate(0.193 0.285)"/>
                <path style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M2.549,14.78V4.539H8.2c2.419,1.537,4.824,4.387,4.824,10.241H5.664" transform="translate(0.193 0.285)"/>
                <line style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} x2="2.097" transform="translate(17.367 19.498)"/>
                <path style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M20.129,21.285a2.928,2.928,0,0,1,0-4.142" transform="translate(0.193 0.285)"/>
                <path style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M21.713,10.037a2.748,2.748,0,0,1-2.28,4.3,2.73,2.73,0,0,1-2.16-1.05" transform="translate(0.193 0.285)"/>
                <path style={{stroke: '#c6c6c6',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M21.713,10.037l-4.44,3.25-.9-1.471" transform="translate(0.193 0.285)"/>
            </svg>
        </span>
    )
}

MachineIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const ManageMachineIcon = ({size, className, style}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            style={style}
            viewBox="0 0 24 24">
                <rect style={{fill: 'none'}} width="24" height="24"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M11.136,20.647H9.9a2.066,2.066,0,0,1-2.05-2.06,2.053,2.053,0,0,1,2.05-2.05h1.235" transform="translate(0 -0.092)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M10.947,8.366,7.3,2.092,2.79,3.825,1.028,9.679" transform="translate(0 -0.092)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M20.383,9.267V3.915H14.728C12.309,5.453,9.9,8.3,9.9,14.157h1.262" transform="translate(0 -0.092)"/>
                <line style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} x1="2.097" transform="translate(3.661 18.498)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M2.8,20.661a2.927,2.927,0,0,0,0-4.141" transform="translate(0 -0.092)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round', strokeMiterlimit: 10, fill: 'none'}} d="M1.218,9.414a2.748,2.748,0,0,0,2.28,4.3,2.73,2.73,0,0,0,2.16-1.05" transform="translate(0 -0.092)"/>
                <path style={{stroke: '#7f8494',strokeLinecap: 'round',strokeLinejoin: 'round', fill: 'none'}} d="M1.218,9.414l4.44,3.25.9-1.471" transform="translate(0 -0.092)"/>
                <circle style={{stroke: '#49cb5c', strokeMiterlimit: 10, fill: 'none'}} cx="1.66" cy="1.66" r="1.66" transform="translate(16.56 15.111)"/>
                <path style={{stroke: '#49cb5c', strokeMiterlimit: 10, fill: 'none'}} d="M22.109,17.711a3.9,3.9,0,0,1-.538,1.3l.766.762a5.089,5.089,0,0,1-1.2,1.207l-.77-.77a3.928,3.928,0,0,1-1.3.538v1.087a5,5,0,0,1-1.7,0V20.748a3.937,3.937,0,0,1-1.3-.538l-.769.77a4.986,4.986,0,0,1-1.2-1.2l.766-.766a4,4,0,0,1-.534-1.3H13.251a4.633,4.633,0,0,1-.074-.847,4.7,4.7,0,0,1,.074-.851h1.086a3.937,3.937,0,0,1,.538-1.3l-.77-.77a5.016,5.016,0,0,1,1.2-1.2l.766.77a3.916,3.916,0,0,1,1.3-.538V11.893a5,5,0,0,1,1.7,0v1.083a3.907,3.907,0,0,1,1.3.538l.766-.766a5,5,0,0,1,1.2,1.2l-.762.766a3.916,3.916,0,0,1,.538,1.3h1.079a4.792,4.792,0,0,1,.074.851,5.122,5.122,0,0,1-.07.847Z" transform="translate(0 -0.092)"/>
            </svg>
        </span>
    )
}

ManageMachineIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const ManageBatteriesIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 24 24">
                    <rect style={{fill: 'none'}} width="24" height="24" transform="translate(24 24) rotate(180)"/>
                    <path style={{fill: '#83878b'}} d="M19.31,4.32V2.01H16.53V4.32H7.72V1.9H5.14V4.32H2.32V7.21H3.38V17.73H1.97v2.69h8.94a.459.459,0,0,1-.07-.14,2.826,2.826,0,0,1-.17-.4.284.284,0,0,1-.04-.13h-8V18.4h7.65a.191.191,0,0,1-.02-.13,2.956,2.956,0,0,1-.06-.51.528.528,0,0,1-.01-.13H4.04V7.31H19.81v3.98a.539.539,0,0,1,.13.07c.14.06.28.13.41.2a.567.567,0,0,1,.13.08V7.21h1.56V4.32ZM7.06,2.57V4.32H5.81V2.57Zm11.59.1V4.32H17.2V2.67Zm2.72,2.32V6.54H2.98V4.99Z" transform="translate(0.17 0.23)"/>
                    <path style={{fill: '#7f8494'}} d="M5.67,2.44V4.46H7.19V2.44ZM6.93,4.19H5.94V2.7h.99Zm3.65,15.43H2.76V18.53H10.3a.274.274,0,0,1-.02-.13.191.191,0,0,1-.02-.13H2.5v1.61h8.17a.284.284,0,0,1-.04-.13A.3.3,0,0,1,10.58,19.62ZM17.07,2.54V4.46h1.71V2.54Zm1.45,1.65H17.33V2.8h1.19ZM3.91,7.18V17.76H10.2a.528.528,0,0,1-.01-.13.285.285,0,0,1,0-.13H4.17V7.44H19.68v3.79c.04.02.09.04.13.06a.539.539,0,0,1,.13.07V7.18ZM2.85,4.86V6.67H21.51V4.86ZM21.24,6.41H3.11V5.12H21.24Zm-1.43,4.88a.539.539,0,0,1,.13.07V7.18H3.91V17.76H10.2a.528.528,0,0,1-.01-.13.285.285,0,0,1,0-.13H4.17V7.44H19.68v3.79C19.72,11.25,19.77,11.27,19.81,11.29ZM18.78,2.54H17.07V4.46h1.71Zm-.26,1.65H17.33V2.8h1.19ZM10.58,19.62H2.76V18.53H10.3a.274.274,0,0,1-.02-.13.191.191,0,0,1-.02-.13H2.5v1.61h8.17a.284.284,0,0,1-.04-.13A.3.3,0,0,1,10.58,19.62ZM7.19,2.44H5.67V4.46H7.19ZM6.93,4.19H5.94V2.7h.99Zm12.51,0V1.87H16.4V4.19H7.85V1.77H5.01V4.19H2.19V7.34H3.25V17.6H1.83v2.95h9.14a.379.379,0,0,1-.06-.13.459.459,0,0,1-.07-.14H2.1V17.87H3.51V7.08H2.45V4.46H5.27V2.04H7.59V4.46h9.08V2.14h2.51V4.45h2.73V7.08H20.35v4.48a.567.567,0,0,1,.13.08.353.353,0,0,1,.13.08V7.34h1.56V4.19ZM2.85,6.67H21.51V4.86H2.85Zm.26-1.55H21.24V6.41H3.11Zm16.57,6.11c.04.02.09.04.13.06a.539.539,0,0,1,.13.07V7.18H3.91V17.76H10.2a.528.528,0,0,1-.01-.13.285.285,0,0,1,0-.13H4.17V7.44H19.68ZM17.07,2.54V4.46h1.71V2.54Zm1.45,1.65H17.33V2.8h1.19ZM10.3,18.53a.274.274,0,0,1-.02-.13.191.191,0,0,1-.02-.13H2.5v1.61h8.17a.284.284,0,0,1-.04-.13.3.3,0,0,1-.05-.13H2.76V18.53ZM5.67,2.44V4.46H7.19V2.44ZM6.93,4.19H5.94V2.7h.99Zm-4.08.67V6.67H21.51V4.86ZM21.24,6.41H3.11V5.12H21.24ZM5.67,2.44V4.46H7.19V2.44ZM6.93,4.19H5.94V2.7h.99ZM17.07,2.54V4.46h1.71V2.54Zm1.45,1.65H17.33V2.8h1.19ZM3.91,7.18V17.76H10.2a.528.528,0,0,1-.01-.13.285.285,0,0,1,0-.13H4.17V7.44H19.68v3.79c.04.02.09.04.13.06a.539.539,0,0,1,.13.07V7.18Zm6.67,12.44H2.76V18.53H10.3a.274.274,0,0,1-.02-.13.191.191,0,0,1-.02-.13H2.5v1.61h8.17a.284.284,0,0,1-.04-.13A.3.3,0,0,1,10.58,19.62ZM2.85,4.86V6.67H21.51V4.86ZM21.24,6.41H3.11V5.12H21.24ZM10.58,19.62H2.76V18.53H10.3a.274.274,0,0,1-.02-.13.191.191,0,0,1-.02-.13H2.5v1.61h8.17a.284.284,0,0,1-.04-.13A.3.3,0,0,1,10.58,19.62ZM3.91,7.18V17.76H10.2a.528.528,0,0,1-.01-.13.285.285,0,0,1,0-.13H4.17V7.44H19.68v3.79c.04.02.09.04.13.06a.539.539,0,0,1,.13.07V7.18ZM2.85,4.86V6.67H21.51V4.86ZM21.24,6.41H3.11V5.12H21.24ZM17.07,2.54V4.46h1.71V2.54Zm1.45,1.65H17.33V2.8h1.19ZM5.67,2.44V4.46H7.19V2.44ZM6.93,4.19H5.94V2.7h.99Z" transform="translate(0.17 0.23)"/>
                    <rect style={{fill: '#83878b'}} width="1.916" height="0.664" transform="translate(17.088 9.495)"/>
                    <path style={{fill: '#7f8494'}} d="M18.964,10.06H16.787V9.134h2.177ZM17.049,9.8H18.7V9.4H17.049Z" transform="translate(0.17 0.23)"/>
                    <path style={{fill: '#83878b'}} d="M6.865,8.588H6.2v.777H5.424v.665H6.2v.777h.665V10.03h.777V9.365H6.865Z" transform="translate(0.17 0.23)"/>
                    <path style={{fill: '#7f8494'}} d="M7,10.938H6.069v-.777H5.293V9.234h.776V8.457H7v.777h.777v.927H7Zm-.665-.262h.4V9.9h.777V9.5H6.734V8.719h-.4V9.5H5.555v.4h.776Z" transform="translate(0.17 0.23)"/>
                    <circle style={{stroke: '#6dba66',strokeLinecap: 'round',strokeMiterlimit: 10, fill: 'none'}} cx="1.66" cy="1.66" r="1.66" transform="translate(15.231 15.752)"/>
                    <path style={{stroke: '#6dba66',strokeLinecap: 'round',strokeMiterlimit: 10, fill: 'none'}} d="M21.76,17.18a4.719,4.719,0,0,1-.07.85H20.61l-.06.24a.928.928,0,0,1-.04.13c-.01.04-.03.09-.04.13a4.6,4.6,0,0,1-.4.8l.29.29.14.13.34.34a1.393,1.393,0,0,1-.15.19,1.7,1.7,0,0,1-.1.14,1.538,1.538,0,0,1-.12.13,5.36,5.36,0,0,1-.83.75l-.77-.77c-.01.01-.02.01-.03.02a3.956,3.956,0,0,1-1.27.52v1.08a4.556,4.556,0,0,1-1.7,0V21.07a3.9,3.9,0,0,1-1.26-.52c-.01-.01-.02-.01-.03-.02l-.77.77a5.005,5.005,0,0,1-.84-.75c-.04-.04-.08-.09-.12-.13s-.07-.09-.1-.14a2.2,2.2,0,0,1-.14-.18l.35-.35.12-.13.29-.29a3.949,3.949,0,0,1-.39-.8.647.647,0,0,1-.04-.13.929.929,0,0,1-.04-.13l-.06-.24H11.75a1.241,1.241,0,0,1-.03-.27.507.507,0,0,1-.02-.13.528.528,0,0,1-.01-.13c-.01-.1-.01-.21-.01-.32a4.8,4.8,0,0,1,.07-.85h1.09a3.686,3.686,0,0,1,.54-1.29l-.77-.77a5.107,5.107,0,0,1,1.2-1.21l.77.77a3.864,3.864,0,0,1,1.29-.53V12.21a5.2,5.2,0,0,1,1.7,0V13.3a3.916,3.916,0,0,1,1.3.53l.76-.76a.176.176,0,0,1,.05.04,23131.258,23131.258,0,0,0,.26.2,3.691,3.691,0,0,1,.41.38.864.864,0,0,1,.13.14,1.738,1.738,0,0,1,.13.15,3.155,3.155,0,0,1,.22.29l-.22.22-.13.13-.13.14-.28.28a4.159,4.159,0,0,1,.28.51,3.054,3.054,0,0,1,.13.32,3.471,3.471,0,0,1,.13.46h1.08A4.8,4.8,0,0,1,21.76,17.18Z" transform="translate(0.17 0.23)"/>
            </svg>
        </span>
    )
}

ManageBatteriesIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const NotificationIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 24 24">
                <g transform="translate(-1252 -23)">
                <g transform="translate(1252 23)">
                <rect style={{fill: 'none'}} width="24" height="24"/>
                <path style={{fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10}} d="M5.576,9.951a6.428,6.428,0,0,1,6.62-6.2,6.608,6.608,0,0,1,6.24,6.7v6.39l1,1.45a1,1,0,0,1-.82,1.57H5.386a1,1,0,0,1-.82-1.57l1-1.45v-3.95" transform="translate(-0.385 -0.061)"/>
                <path style={{fill: 'none', stroke: '#49cb5c', strokeLinecap: 'round', strokeMiterlimit: 10}} d="M13.4,21.534a1.406,1.406,0,0,1-2.811,0" transform="translate(-0.385 -0.061)"/>
                <path style={{fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10}} d="M10.6,3.9V2.461a1.405,1.405,0,0,1,2.81,0V3.9" transform="translate(-0.385 -0.061)"/></g>
                <circle style={{fill: '#ea3b3b'}} cx="2.5" cy="2.5" r="2.5" transform="translate(1271 23)"/></g>
            </svg>
        </span>
    )
}

NotificationIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}


export const UploadIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 48 48">
                    <rect style={{opacity: 0}} width="48" height="48"/>
                    <g transform="translate(-24.129 1.56)">
                    <path style={{fill: '#7f8494'}} d="M61.833,43.441H34.112a2.987,2.987,0,0,1-2.983-2.983V14.9a.994.994,0,0,1,1.989,0V40.458a1,1,0,0,0,.994.994H61.833a1,1,0,0,0,.994-.994V4.423a1,1,0,0,0-.994-.994H34.112a1,1,0,0,0-.994.994V8.341a.994.994,0,0,1-1.989,0V4.423A2.987,2.987,0,0,1,34.112,1.44H61.833a2.985,2.985,0,0,1,2.983,2.983V40.458A2.985,2.985,0,0,1,61.833,43.441Z" transform="translate(0 0)"/>
                    <path style={{fill: '#7f8494'}} d="M52.244,17.489h-8.41a.994.994,0,0,1,0-1.989h8.41a.994.994,0,1,1,0,1.989Z" transform="translate(11.578 13.901)"/>
                    <path style={{fill: '#7f8494'}} d="M40.913,17.489h-8.79a.994.994,0,1,1,0-1.989h8.79a.994.994,0,0,1,0,1.989Z" transform="translate(0 13.901)"/>
                    <path style={{fill: '#7f8494'}} d="M43.78,24.747a8.252,8.252,0,0,1-8.231-8.253.994.994,0,1,1,1.989,0,6.254,6.254,0,1,0,12.509,0,.994.994,0,1,1,1.989,0A8.264,8.264,0,0,1,43.78,24.747Z" transform="translate(4.37 13.901)"/>
                    <path style={{fill: '#6dba66'}} d="M55.077,8.422H35.06a.994.994,0,0,1,0-1.989H55.077a.994.994,0,1,1,0,1.989Z" transform="translate(2.904 4.937)"/>
                    <path style={{fill: '#6dba66'}} d="M55.077,11.617H35.06a.994.994,0,0,1,0-1.989H55.077a.994.994,0,1,1,0,1.989Z" transform="translate(2.904 8.096)"/></g>
            </svg>
        </span>
    )
}

UploadIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const EditIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 16 16">
                <rect style={{ fill: 'none' }} width="16" height="16"/><g transform="translate(-1.816 -1.43)">
                <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M7.006,2.43h6.4a.743.743,0,0,1,.741.741V5.118" transform="translate(-1.087 0)"/>
                <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M13.059,15.182v1.77a.743.743,0,0,1-.741.741H3.557a.743.743,0,0,1-.741-.741V6.62" transform="translate(0 -1.087)"/>
                <rect style={{ fill: 'none', stroke: '#6dba66', strokeLinecap: 'round', strokeLinejoin: 'round' }} width="8.185" height="2.107" transform="translate(8.329 12.46) rotate(-45)"/>
                <path style={{ fill: 'none', stroke: '#6dba66', strokeLinecap: 'round', strokeLinejoin: 'round' }} d="M11.5,17.462l-2.215.725.725-2.215Z" transform="translate(-1.677 -3.512)"/>
                <path style={{ fill: 'none', stroke: '#6dba66', strokeLinecap: 'round', strokeLinejoin: 'round' }} d="M1.053,0h.658a0,0,0,0,1,0,0V2.107a0,0,0,0,1,0,0H1.053A1.053,1.053,0,0,1,0,1.053v0A1.053,1.053,0,0,1,1.053,0Z" transform="translate(16.816 6.952) rotate(135)"/>
                <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeLinejoin: 'round'}} d="M5.917,2.432v3.1h-3.1Z" transform="translate(-0.001 -0.001)"/></g>
            </svg>
        </span>
    )
}

EditIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const DeleteIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 16 16">
                <rect style={{ fill: 'none' }} width="16" height="16"/>
                <g transform="translate(-1.732 -1.196)">
                <line style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} x1="0.167" y1="2.583" transform="translate(4.573 5.516)"/>
                <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M5.371,12.271l.29,4.376a1.391,1.391,0,0,0,1.386,1.386h6.27A1.384,1.384,0,0,0,14.7,16.647l.646-9.717" transform="translate(-0.45 -1.414)"/>
                <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M1,0H2.619a1,1,0,0,1,1,1v.346a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z" transform="translate(7.922 1.774)"/>
                <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} y2="4.393" transform="translate(7.57 8.519)"/>
                <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} y2="4.393" transform="translate(9.732 8.519)"/>
                <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} y2="4.393" transform="translate(11.894 8.519)"/>
                <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M15.732,5.221v.8h-12v-.8A1.6,1.6,0,0,1,5.324,3.629H14.14A1.6,1.6,0,0,1,15.732,5.221Z" transform="translate(0 -0.509)"/></g>
            </svg>
        </span>
    )
}

DeleteIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const RevealIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 16 16">
                <rect style={{ fill: 'none' }} width="16" height="16"/>
                <g transform="translate(-737 -358.073)">
                    <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M15.882,10.174s-3.134,4.1-7,4.1-7-4.1-7-4.1,3.134-4.1,7-4.1S15.882,10.174,15.882,10.174Z" transform="translate(736.118 356)"/>
                    <path style={{ fill: 'none', stroke: '#49cb5c', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M13.143,11.043v.042A2.055,2.055,0,1,1,11.088,9.03a1.984,1.984,0,0,1,.948.235" transform="translate(733.914 355.089)"/>
                </g>
            </svg>
        </span>
    )
}

RevealIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const DropdownIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 16 16">
                <g transform="translate(-1316 -31)">
                    <rect style={{ fill: 'none' }} width="16" height="16" transform="translate(1316 31)"/>
                    <path  style={{ fill: 'none', stroke: '#49cb5c', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: 2 }} d="M-22132.8-20592.066l4,4,4-4" transform="translate(23453.299 20629.566)"/>
                </g>
            </svg>
        </span>
    )
}

DropdownIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const CustomerIcon = ({size, className}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 24 24">
                <rect style={{ fill: 'none' }} width="24" height="24"/>
                <g transform="translate(0.177 -0.25)">
                    <circle style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} cx="3.478" cy="3.478" r="3.478" transform="translate(8.522 3.25)"/>
                    <rect style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} width="1.778" height="1.778" transform="translate(10.742 14.835) rotate(-45)"/>
                    <path style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} d="M12,16.092l-1.295,3.2L12,20.75l1.3-1.454Z"/>
                    <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M6.162,18.326V14a2,2,0,0,1,2-2h7.676a2,2,0,0,1,2,2v4.323"/>
                    <circle style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} cx="1.932" cy="1.932" r="1.932" transform="translate(2.134 4.016)"/>
                    <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M.823,12.924v-2.4A1.111,1.111,0,0,1,1.934,9.412H6.2a1.111,1.111,0,0,1,1.111,1.111"/>
                    <circle style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} cx="1.932" cy="1.932" r="1.932" transform="translate(18.002 4.016)"/>
                    <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M23.177,12.924v-2.4a1.111,1.111,0,0,0-1.111-1.111H17.8a1.111,1.111,0,0,0-1.111,1.111"/>
                </g>
            </svg>
        </span>
    )
}

CustomerIcon.defaultProps = {
    size: 16,
    className: 'anticon'
}

export const BurgerIcon = ({size, className, onClick}:any) =>
{
    return (<span className={className} style={{ width: size, height: size, display: 'block'}} onClick={onClick}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 24 24">
                <g transform="translate(-269 -23)">
                    <rect style={{ fill: 'none' }} width="24" height="24" transform="translate(269 23)"/>
                    <rect style={{ fill: '#3497da' }} width="20" height="2" transform="translate(271 27)"/>
                    <rect style={{ fill: '#3497da' }} width="20" height="2" transform="translate(271 34)"/>
                    <rect style={{ fill: '#3497da' }} width="20" height="2" transform="translate(271 41)"/>
                </g>
            </svg>
        </span>
    )
}

BurgerIcon.defaultProps = {
    size: 24,
    className: 'anticon'
}

export const PhoneIcon = ({size, className, onClick}:any) =>
{
    return (<span className={className} onClick={onClick}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 24 24">
                <rect style={{ fill: 'none' }} width="24" height="24"/>
                <g transform="translate(0.727 0.565)">
                        <path style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} d="M6.926,15.5l5.963,5.963a3.77,3.77,0,0,0,5.333,0h0L20.378,19.3a1.19,1.19,0,0,0,0-1.683l-2.2-2.2a1.19,1.19,0,0,0-1.683,0l-1.315,1.314a1.19,1.19,0,0,1-1.683,0L9.188,12.426a1.19,1.19,0,0,1,0-1.682L10.5,9.429a1.19,1.19,0,0,0,0-1.683l-2.2-2.2a1.191,1.191,0,0,0-1.683,0L4.461,7.7l-.142.142a3.569,3.569,0,0,0,0,5.049"/>
                        <line style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} x1="3.888" y1="3.888" transform="translate(15.83 16.078)"/>
                        <line style={{ fill: 'none', stroke: '#7f8494', strokeMiterlimit: 10, strokeLinecap: 'round' }} x1="3.879" y1="3.879" transform="translate(5.959 6.207)"/>
                        <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} y1="1.932" transform="translate(9.658 1.435)"/>
                        <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} x1="1.932" transform="translate(12.657 6.367)"/>
                    <line style={{ fill: 'none', stroke: '#6dba66', strokeLinejoin: 'round', strokeLinecap: 'round' }} y1="1.811" x2="1.811" transform="translate(11.158 3.056)"/>
                </g>
            </svg>
        </span>
    )
}

PhoneIcon.defaultProps = {
    size: 24,
    className: 'anticon'
}

export const PinIcon = ({size, className, onClick}:any) =>
{
    return (<span className={className} style={{ verticalAlign: 'middle'}} onClick={onClick}>
             <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            width={`${size}`}
            height={`${size}`}
            viewBox="0 0 24 24">
                    <rect style={{ fill: 'none' }} width="24" height="24"/>
                    <g transform="translate(-2.222 -1.779)">
                        <path style={{ fill: 'none', stroke: '#7f8494', strokeLinecap: 'round', strokeMiterlimit: 10 }} d="M7.279,12.652a45.653,45.653,0,0,0,3.088,4.127s5.145-6.013,5.145-8.855a5.145,5.145,0,0,0-10.291,0,6.322,6.322,0,0,0,.8,2.583"/>
                        <circle style={{ fill: 'none', stroke: '#6dba66', strokeLinecap: 'round', strokeMiterlimit: 10 }}  cx="2.013" cy="2.013" r="2.013" transform="translate(8.354 5.911)"/>
                    </g>
            </svg>
        </span>
    )
}

PinIcon.defaultProps = {
    size: 24,
    className: 'anticon'
}